import { render, staticRenderFns } from "./HeaderUserSigned.vue?vue&type=template&id=2537464f&scoped=true"
import script from "./HeaderUserSigned.vue?vue&type=script&lang=ts"
export * from "./HeaderUserSigned.vue?vue&type=script&lang=ts"
import style0 from "./HeaderUserSigned.vue?vue&type=style&index=0&id=2537464f&prod&scoped=true&lang=scss"
import style1 from "./HeaderUserSigned.vue?vue&type=style&index=1&id=2537464f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2537464f",
  null
  
)

export default component.exports